import { reflect } from '@effector/reflect'

import * as chat from '@/entities/chat'
import { modalOpener } from '@/shared/ui/modal'

import * as model from './model'
import { MessageHideDialog as View } from './view'

export const MessageHideDialog = {
    View: reflect({
        view: View,
        bind: {
            reporter: chat.$userInfo,
            onHideClick: model.hideButtonClicked,
            onBackButtonClick: model.backButtonClicked,
            nonInteractive: model.$interactionDisabled,
        },
    }),
    model,
}

model.showFx.use(modalOpener(MessageHideDialog.View))
